<template>
  <vx-card title="Update Stock Take">
    <div class="vx-row align-center">
      <div class="vx-col flex items-center justify-center flex-col  mx-auto ">
        <form>
          <div class="vx-row">
            <div class="vx-col w-full ">
              <vs-input size="large" v-validate="'max:5|numeric'" label="Stock Take Quantity" name="qty"
                v-model="data.qty" class="mt-5 input-center w-full" max="5" />
              <span class="text-danger text-sm" v-show="errors.has('qty')">{{
                errors.first('qty')
              }}</span>
            </div>

            <div class="vx-col w-full">
              <vs-input size="large" v-validate="'max:50'" label="Remarks" name="remarks" v-model="data.remarks"
                class="mt-5 input-center w-full" />
              <span class="text-danger text-sm" v-show="errors.has('remarks')">{{
                errors.first('remarks')
              }}</span>
            </div>
          </div>
          <vs-button class="mt-5 w-full" @click="updateGrGsQty()" size="large">SAVE</vs-button>
        </form>
 
      </div>
    </div>
  </vx-card>
</template>
<script>
import StatisticsCardLine from '@/components/statistics-cards/StatisticsCardLine.vue'
import { axiosMixin } from '../../mixin/axiosMixin';
import { alertMixin } from '../../mixin/alertMixin';
export default {
  mixins: [axiosMixin, alertMixin],
  components: {
    StatisticsCardLine,
  },
  data() {
    return {
      data: {
        qty: null,
        remarks: '',
      },
    };
  },
  props: {
    inventory: {
      type: Object,
      default: false,
    },
  },
  methods: {
    startLoading() {
      this.$vs.loading({
        container: '#container',
        scale: 0.6
      });
    },
    stopLoading() {
      this.$vs.loading.close('#container > .con-vs-loading');
    },
    updateGrGsQty() {
      this.startLoading();
      // combine data to inventory object
      //remove id,created_at,updated_at,masterStockCodeName,SubStockCodeName from inventory
      delete this.inventory.id;
      delete this.inventory.created_at;
      delete this.inventory.updated_at;
      delete this.inventory.masterStockCodeName;
      delete this.inventory.SubStockCodeName;
      delete this.inventory.status;
      delete this.inventory.compIdName;

      //assign  data.remarks to inventory.remarks
      this.inventory.remarks = this.data.remarks;

      //add currentDate to inventory.currentDate
      this.inventory.currentDate = new Date().toISOString().slice(0, 10);

      this.data = Object.assign(this.data, this.inventory);

      this.aronPostPut('stocktakes', 'add', this.data, '')
        .then(response => {
          this.$emit('close');
          this.stopLoading();
        })
        .catch(error => {
          console.log('error:', error);
          this.stopLoading();
        })

    }

  },
  mounted() {
    //  this.getData();
  },
  created() {

  }
};
</script>
<style>
.input-center {
  text-align: center;
}

.input-center input {
  text-align: center;
}
</style>
